import React, { useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const AddChannel = ({list}) => {
    const schema = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required().max(200, 'description must be upto 250 characters.')
    });
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/channels`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                reset();
                closeModal("add_channel");
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    useEffect(() => {
        const modalElement = document.getElementById('add_channel');

        const handleClose = () => reset();

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);

    return (
        <div id="add_channel" className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Channel</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel Name <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" {...register('name')}/>
                                        <div className="text-sm text-danger">
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description <span className="text-danger">*</span></label>
                                        <textarea className="form-control" {...register('description')} rows={3}></textarea>
                                        <div className="text-sm text-danger">
                                            {errors.description && <p>{errors.description.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddChannel